var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkshopbg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 326,
    viewBox: "0 0 1440 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1440 0V323.625C1440 323.625 1269 260.966 1080 295.637C891 330.309 708.5 302.739 625.5 286.447C542.5 270.156 420 274.751 266.5 305.245C113 335.739 0 323.625 0 323.625V0Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopbg2);
export default __webpack_public_path__ + "static/media/workshopbg_2.61e31216c06ecc8ad586f23b47178847.svg";
export { ForwardRef as ReactComponent };